export default __webpack_public_path__ + "aa663716b012caf3437e80c6ff7d7f39.png";